// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_dqPaH {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: var(--_00000033-shadow);
    z-index: 5000;
    outline: none;
  }

  .subContainer_QIeTz {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 512px;
    background: var(--f4-background);
    border-radius: 8px;
    padding-bottom: 15px;
  }

  .cancelButton_MUX3r {
    border: 1px solid gray;
    background: var(--white-color);
    height: 35px;
    width: 100px;
    border-radius: 6px;
    border: 1px solid #cbcbcb;
    color: #232222;
    font-weight: 500;
    font-family: Inter;
    cursor: pointer;
  }

  .buttonUpdate_wJa7Y {
    background: var(--_10a37f-background);
    color: var(--white-color);
    font-weight: 500;
    font-family: Inter;
    cursor: pointer;
    height: 35px;
    width: 100%;
    border-radius: 6px;
    border: none;
    color: var(--white-color);
    font-weight: 500;
    font-family: Inter;
    cursor: pointer;
  }

  .containerCustom_Pcdaw {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: var(--_00000033-shadow);
    z-index: 5000;
  }

  .content_yvT1b {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 480px; 
    overflow: hidden;
  }

  .children_content_G2Vde {
    padding: 22px 22px;
    margin-left: 15px;
    margin-right: 15px;
    background-color: var(--white-background);
    border-radius: 8px;
    max-height: 50vh;
    overflow: scroll;
  }





  .textarea_RnudC {
    width: 100%;
    height: 80px;
    border-radius: 6px;
    border: 1px solid var(--f4-background);
    padding: 0px;
    font-size: 14px;
    font-weight: 500;
    color: #292a2b;
    resize: none;
    background-color: var(--f4-background);
    outline: none;
  }

  .title_kXAPk {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: center;
    width: 100%;
    padding-left: 16px;
  }

  .iconTitle_HNRgr {
    display: flex;
    align-items: center;
    border-radius: 10px;
  }

  .gridContainer_ZOUCb {
    display: grid;
    gap: 13px;
  }

  .signInOption_UJmVX {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    background-color: var(--white-background);
    width: auto;
    border-radius: 6px;
    height: 34px;
    border: 1px solid #cbcbcbad;
    cursor: pointer;
    font-family: Inter;
    font-weight: 500;
  }

  .serverConfigContainer_yfCls {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    column-gap: 24px;
  }

  .dropdownContainer_EAGJb {
    display: flex;
    flex-direction: column;
  }

  .label_kxILZ {
    color: #292a2b;
    font-family: Inter;
    font-weight: 500;
    cursor: pointer;
    margin: 0px;
  }

  .labelInput_jvcJs {
    color: #292a2b;
    font-family: Inter;
    font-weight: 500;
  }

  .inputContainer_gnPJn {
    display: flex;
    gap: 4px;
    padding: 8px 16px;
    background: var(--f1-background);
    border-radius: 6px;
  }

  .input_qMgUb {
    padding: 0px;
    margin: 0px;
    height: 20px;
    border: none;
    outline: none;
    background-color: transparent;
    color: var(--black-color);
    font-size: 14px;
  }

  .eye_Zmx4W {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }

  @keyframes scaleInCenter_tfZ9J {
    0% {
      transform: scale(0);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  .checkOk_PpXbu {
    font-size: 15px;
    color: var(--white-color);
    animation: checkOk_PpXbu 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }

  @keyframes checkOk_PpXbu {
    0% {
      transform: scale(0);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  .loader_G2P3Q {
    width: 20px;
    height: 20px;
    border: 2px solid var(--white-color);
    border-bottom-color: var(--_10a37f-background);
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation_Khyjy 1s linear infinite;
  }

  @keyframes rotation_Khyjy {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .footer_YSUbk {
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    max-width: 500px;
    gap: 4px;
    box-sizing: border-box;
    padding: 10px 0px;
    bottom: 15px;
    border-radius: 10px;
    font-size: 12px;
    color: var(--_71717a-color);
    margin-top: 14px;
    margin-bottom: 10px;
    @media (width<=528px) {
      & {
        padding: 30px 10px 22px 10px;
      }
    }
  }

  .buttonContainer_xyzWO {
    display: flex;
    gap: 10px;
  }
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/ModalsAddConnection/LeyAntifraudeModalAddConnection.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;;;;;EAMA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,sCAAsC;IACtC,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,yCAAyC;IACzC,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE;MACE,mBAAmB;MACnB,UAAU;IACZ;IACA;MACE,mBAAmB;MACnB,UAAU;IACZ;EACF;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,uEAAiE;EACnE;;EAEA;IACE;MACE,mBAAmB;MACnB,UAAU;IACZ;IACA;MACE,mBAAmB;MACnB,UAAU;IACZ;EACF;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,8CAA8C;IAC9C,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,4CAAsC;EACxC;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,QAAQ;IACR,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB;MACE;QACE,4BAA4B;MAC9B;IACF;EACF;;EAEA;IACE,aAAa;IACb,SAAS;EACX","sourcesContent":[".container {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--_00000033-shadow);\n    z-index: 5000;\n    outline: none;\n  }\n\n  .subContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 512px;\n    background: var(--f4-background);\n    border-radius: 8px;\n    padding-bottom: 15px;\n  }\n\n  .cancelButton {\n    border: 1px solid gray;\n    background: var(--white-color);\n    height: 35px;\n    width: 100px;\n    border-radius: 6px;\n    border: 1px solid #cbcbcb;\n    color: #232222;\n    font-weight: 500;\n    font-family: Inter;\n    cursor: pointer;\n  }\n\n  .buttonUpdate {\n    background: var(--_10a37f-background);\n    color: var(--white-color);\n    font-weight: 500;\n    font-family: Inter;\n    cursor: pointer;\n    height: 35px;\n    width: 100%;\n    border-radius: 6px;\n    border: none;\n    color: var(--white-color);\n    font-weight: 500;\n    font-family: Inter;\n    cursor: pointer;\n  }\n\n  .containerCustom {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--_00000033-shadow);\n    z-index: 5000;\n  }\n\n  .content {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    max-width: 480px; \n    overflow: hidden;\n  }\n\n  .children_content {\n    padding: 22px 22px;\n    margin-left: 15px;\n    margin-right: 15px;\n    background-color: var(--white-background);\n    border-radius: 8px;\n    max-height: 50vh;\n    overflow: scroll;\n  }\n\n\n\n\n\n  .textarea {\n    width: 100%;\n    height: 80px;\n    border-radius: 6px;\n    border: 1px solid var(--f4-background);\n    padding: 0px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #292a2b;\n    resize: none;\n    background-color: var(--f4-background);\n    outline: none;\n  }\n\n  .title {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    justify-content: center;\n    width: 100%;\n    padding-left: 16px;\n  }\n\n  .iconTitle {\n    display: flex;\n    align-items: center;\n    border-radius: 10px;\n  }\n\n  .gridContainer {\n    display: grid;\n    gap: 13px;\n  }\n\n  .signInOption {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 16px;\n    background-color: var(--white-background);\n    width: auto;\n    border-radius: 6px;\n    height: 34px;\n    border: 1px solid #cbcbcbad;\n    cursor: pointer;\n    font-family: Inter;\n    font-weight: 500;\n  }\n\n  .serverConfigContainer {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    column-gap: 24px;\n  }\n\n  .dropdownContainer {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .label {\n    color: #292a2b;\n    font-family: Inter;\n    font-weight: 500;\n    cursor: pointer;\n    margin: 0px;\n  }\n\n  .labelInput {\n    color: #292a2b;\n    font-family: Inter;\n    font-weight: 500;\n  }\n\n  .inputContainer {\n    display: flex;\n    gap: 4px;\n    padding: 8px 16px;\n    background: var(--f1-background);\n    border-radius: 6px;\n  }\n\n  .input {\n    padding: 0px;\n    margin: 0px;\n    height: 20px;\n    border: none;\n    outline: none;\n    background-color: transparent;\n    color: var(--black-color);\n    font-size: 14px;\n  }\n\n  .eye {\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n  }\n\n  @keyframes scaleInCenter {\n    0% {\n      transform: scale(0);\n      opacity: 1;\n    }\n    100% {\n      transform: scale(1);\n      opacity: 1;\n    }\n  }\n\n  .checkOk {\n    font-size: 15px;\n    color: var(--white-color);\n    animation: checkOk 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n  }\n\n  @keyframes checkOk {\n    0% {\n      transform: scale(0);\n      opacity: 1;\n    }\n    100% {\n      transform: scale(1);\n      opacity: 1;\n    }\n  }\n\n  .loader {\n    width: 20px;\n    height: 20px;\n    border: 2px solid var(--white-color);\n    border-bottom-color: var(--_10a37f-background);\n    border-radius: 50%;\n    display: inline-block;\n    box-sizing: border-box;\n    animation: rotation 1s linear infinite;\n  }\n\n  @keyframes rotation {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  .footer {\n    width: 100%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    max-width: 500px;\n    gap: 4px;\n    box-sizing: border-box;\n    padding: 10px 0px;\n    bottom: 15px;\n    border-radius: 10px;\n    font-size: 12px;\n    color: var(--_71717a-color);\n    margin-top: 14px;\n    margin-bottom: 10px;\n    @media (width<=528px) {\n      & {\n        padding: 30px 10px 22px 10px;\n      }\n    }\n  }\n\n  .buttonContainer {\n    display: flex;\n    gap: 10px;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_dqPaH`,
	"subContainer": `subContainer_QIeTz`,
	"cancelButton": `cancelButton_MUX3r`,
	"buttonUpdate": `buttonUpdate_wJa7Y`,
	"containerCustom": `containerCustom_Pcdaw`,
	"content": `content_yvT1b`,
	"children_content": `children_content_G2Vde`,
	"textarea": `textarea_RnudC`,
	"title": `title_kXAPk`,
	"iconTitle": `iconTitle_HNRgr`,
	"gridContainer": `gridContainer_ZOUCb`,
	"signInOption": `signInOption_UJmVX`,
	"serverConfigContainer": `serverConfigContainer_yfCls`,
	"dropdownContainer": `dropdownContainer_EAGJb`,
	"label": `label_kxILZ`,
	"labelInput": `labelInput_jvcJs`,
	"inputContainer": `inputContainer_gnPJn`,
	"input": `input_qMgUb`,
	"eye": `eye_Zmx4W`,
	"checkOk": `checkOk_PpXbu`,
	"loader": `loader_G2P3Q`,
	"rotation": `rotation_Khyjy`,
	"footer": `footer_YSUbk`,
	"buttonContainer": `buttonContainer_xyzWO`,
	"scaleInCenter": `scaleInCenter_tfZ9J`
};
export default ___CSS_LOADER_EXPORT___;
